import React, { useEffect, useState } from "react";
import "./App.css";
import { Paper } from "@mui/material";
import "react-resizable/css/styles.css";
import Chart from "./chart";

function Preview(props: any) {
  const [viewType, setViewType] = useState("");
  const [widgetData, setWidgetData] = useState<any>("");
  const [print, setPrint] = useState(false);
  const [printObj, setPrintObj] = useState({
    print: false,
    viewType: "Pie Chart",
  });

  function handleAfterPrint(data: any) {
    setPrint(data);
    let obj = { print: data, viewType: printObj.viewType };
    setPrintObj(obj);
    console.log("This is inside preview.tsx file: ", data);
  }
  useEffect(() => {
    console.log("props are inside preview ", props);
    console.log("Export Click in Preview Componenet", props.widgetData);

    if (props.viewType !== viewType) {
      setViewType(props.viewType);
    }

    if (props.widgetData !== widgetData) {
      let obj: any = {};
      obj["preview"] = true;
      if (props.previewType === "CreateWidget") {
        obj["previewType"] = "CreateWidget";
      } else if (props.previewType === "AddWidget") {
        obj["previewType"] = "AddWidget";
      } else if (props.previewType === "EditWidget") {
        obj["previewType"] = "EditWidget";
      }
      obj["queryObj"] = props.widgetData;
      setWidgetData(obj);
    }
  }, [props.viewType, props.widgetData]);
  return (
    <div style={{ width: 600, height: 300 }}>
      <Chart
        viewType={viewType}
        widgetData={widgetData}
        widgetName={props.widgetName}
        timeOut={1000}
        print={props.printObj}
        parentCallbackPrint={handleAfterPrint}
        export={props.exportClick}
        exportAfterCallback={props.exportAfterCallback}
      />
    </div>
  );
}

export default Preview;
